import initialState from './RepresentativeInicialState';
import reducers from './RepresentativeReducer';

export default {
  initialState,
  reducers,
};
